import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    items: [],
    unreadCount: 0,
    loading: false,
  },
  reducers: {
    setNotifications(state, action) {
      state.items = action.payload;
      state.unreadCount = action.payload.filter((n) => !n.read).length;
    },
    addNotification(state, action) {
      // Prepend new real-time notification (unread by default)
      state.items.unshift({ ...action.payload, read: false });
      state.unreadCount += 1;
    },
    markAsRead(state, action) {
      const notification = state.items.find((n) => n.id === action.payload);
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllRead(state) {
      state.items.forEach((n) => (n.read = true));
      state.unreadCount = 0;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { setNotifications, addNotification, markAsRead, markAllRead, setLoading } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;